import { forwardRef } from "react";

interface SearchResultListProps {
  id: string;
  children: React.ReactNode;
}

export const SearchResultList = forwardRef<HTMLUListElement, SearchResultListProps>(({ id, children }, ref) => (
  <ul
    ref={ref}
    id={id}
    role="listbox"
    className="absolute z-popover mt-2 max-h-52 w-full overflow-y-auto rounded-xl border border-border bg-background py-1.5 shadow-xl md:max-h-80"
  >
    {children}
  </ul>
));

SearchResultList.displayName = "SearchResultList";
